export const text = {
  name: "Notifications",
  message: "Message",
  markAllRead: "Mark All as Read",
  noRecordFound: "No Record Found",
};
